import { styled, Box as MuiBox, Stack as MuiStack } from "@mui/material";

export const Stack = styled(MuiStack)`
  &.input-container {
    font-size: 12px;
    gap: 8px;
    padding: 10px 15px;
    flex-direction: row;
    align-items: center;
    .input-label {
      width: 72px;
    }
  }
`;

export const Box = styled(MuiBox)(
  ({ theme }) => `
  &.certificate-input-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${theme.palette.bluegrey[100]};
    .text-field {
      input {
        background-color: white;
        width: 278px;
      }
    }
  }
`
);
